import React, { useEffect, useState } from 'react';
import { getMyProperties, getPropertyById } from '../../../api/services/propertyService';
import { getUnitRequestIdFromNotification } from '../../shared/Notifications/notificationUtils';
import { filterPropertiesByScope } from '../../../utils/propertyScope';
import PropertyUnitRequestsView from './PropertyUnitRequests/PropertyUnitRequestsView';

const LandlordUnitRequests = ({ onNavigate, navigationState = {} }) => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requestNav, setRequestNav] = useState(null);

  useEffect(() => {
    const hasIntent =
      navigationState?.requestId ||
      navigationState?.requestResolveHint ||
      navigationState?.focusRequestOnly;

    if (!hasIntent) return;

    const idFromNotification = navigationState.notification
      ? getUnitRequestIdFromNotification(navigationState.notification)
      : null;
    const requestId = navigationState.requestId || idFromNotification || null;

    setRequestNav({
      requestId,
      focusRequestOnly: Boolean(navigationState.focusRequestOnly),
      openPaymentEvidence: Boolean(navigationState.openPaymentEvidence),
      requestResolveHint: requestId ? null : navigationState.requestResolveHint || null,
    });
  }, [
    navigationState?.requestId,
    navigationState?.notification,
    navigationState?.requestResolveHint,
    navigationState?.focusRequestOnly,
    navigationState?.openPaymentEvidence,
  ]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getMyProperties({ page: 0, size: 100, search: '' });
        const content = res?.data?.content || [];

        const enrichedProperties = await Promise.all(
          content.map(async (property) => {
            if (!property?.id) return property;
            try {
              const detailRes = await getPropertyById(property.id, true);
              if (detailRes?.status === 'success' && detailRes?.data) {
                return { ...property, ...detailRes.data };
              }
            } catch (e) {
              // ignore
            }
            return property;
          })
        );

        const scopedProperties = filterPropertiesByScope(enrichedProperties, 'landlord', {
          includeUnscoped: true,
          inferFromUnits: true,
        });

        const list = (Array.isArray(scopedProperties) ? scopedProperties : [])
          .map((p) => ({
            id: p.id,
            name: p.name || 'Property',
          }))
          .filter((p) => p.id);
        if (!cancelled) setProperties(list);
      } catch (e) {
        console.error(e);
        if (!cancelled) setProperties([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const clearRequestNav = () => setRequestNav(null);

  return (
    <PropertyUnitRequestsView
      properties={properties}
      loadingProperties={loading}
      pageTitle="Unit requests"
      emptyPropertiesMessage="Add a property under Manage Rentals to see tenant unit requests here."
      onNavigate={onNavigate}
      highlightRequestId={requestNav?.requestId}
      focusRequestOnly={requestNav?.focusRequestOnly}
      openPaymentEvidence={requestNav?.openPaymentEvidence}
      requestResolveHint={requestNav?.requestResolveHint}
      onFocusExit={clearRequestNav}
    />
  );
};

export default LandlordUnitRequests;
